import { ErrorCode } from '@ppl/auth';
import type { EmailVerificationError } from './email-verification-error';

export const SendVerificationLinkToEmailErrorWhiteList: ErrorCode[] = [
  ErrorCode.ERROR_TOO_MANY_REQUESTS,
  ErrorCode.ERROR_PARAMETER_INVALID
];

export function getSendVerificationLinkToEmailError(
  i18nService: { translate: (id: string, markers?: { [marker: string]: any }) => string },
  errorCode: ErrorCode
): EmailVerificationError {
  switch (errorCode) {
    case ErrorCode.ERROR_PARAMETER_INVALID:
      return {
        errorCode,
        message: i18nService.translate('Invalid_or_expired_session.')
      };
    case ErrorCode.ERROR_TOO_MANY_REQUESTS:
      return {
        errorCode,
        message: i18nService.translate('Too_many_requests.')
      };
    case ErrorCode.ERROR_SENDING_MAIL:
      return {
        errorCode,
        message: i18nService.translate('Failed_to_send_verification_email._Please_try_again.')
      };
    default:
      return {
        errorCode: ErrorCode.ERROR_UNKNOWN,
        message: i18nService.translate('Unknown_error.')
      };
  }
}
